export const fetchAISummaryFromData = async (data, thunkApi) => {
  try {
    const { ai } = thunkApi.extra.apiService;
    const response = await ai.post("/analyze", data);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
